import React from 'react';
import RecordDate from '../../components/Record/RecordDate';
const RecordPage = () => {
    return (
        <div>
            <div className='text-center mt-8 mb-8 text-2xl font-bold'>대회 선택</div>
            <RecordDate/>
        </div>
    );
};

export default RecordPage;